/* unplugin-vue-components disabled */import { SwipeItem as __unplugin_components_1 } from 'vant/es';
import 'vant/es/swipe-item/style/index';
import { Swipe as __unplugin_components_0 } from 'vant/es';
import 'vant/es/swipe/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "banner"
  }, [_c(__unplugin_components_0, {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l(_vm.bannerList, function (item, index) {
    return _c(__unplugin_components_1, {
      key: index,
      staticClass: "item",
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('on-click', item);
        }
      }
    }, [_c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.image_url
      }
    })]);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };